import { createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5e3969ec")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("button", {
    class: ["btn", _ctx.color],
    disabled: _ctx.cargando,
    type: "submit"
  }, [
    _withDirectives(_createVNode("section", null, [
      _createVNode("span", {
        class: ["spinner-border spinner-border-sm", {
          primarydisabled: _ctx.colorPrimario.includes('btn-primary'),
          outlinedisabled: _ctx.colorPrimario.includes('btn-outline-primary')
        }],
        role: "status",
        "aria-hidden": "true"
      }, null, 2),
      _createVNode("span", {
        class: {
          primarydisabled: _ctx.colorPrimario.includes('btn-primary'),
          outlinedisabled: _ctx.colorPrimario.includes('btn-outline-primary')
        }
      }, _toDisplayString(_ctx.mensaje) + "... ", 3)
    ], 512), [
      [_vShow, _ctx.cargando]
    ]),
    _withDirectives(_createVNode("section", null, [
      _createTextVNode(_toDisplayString(_ctx.texto) + " ", 1),
      _createVNode("i", { class: _ctx.icono }, null, 2)
    ], 512), [
      [_vShow, !_ctx.cargando]
    ])
  ], 10, ["disabled"]))
})